
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy/specified-commercial-transactions",
      function () {
        return require("private-next-pages/policy/specified-commercial-transactions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policy/specified-commercial-transactions"])
      });
    }
  